module.exports = __webpack_public_path__ + "img/pak.30af4fb6.png";